import {
    ChangeDetectorRef,
    Component,
    OnInit,
    Inject,
    AfterViewInit,
    ViewChild,
    ElementRef, Input
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { environment } from '@app/utils/get-api-url';

// import { TemplatesConfigService } from '@app/features/system-settings/general-custom-templates-config/services/templates-config.service';
import { SystemSettingsService } from '@app/services';
import {JobViewService} from "@app/features/customers/customer/jobs-view/service/job-view-service";

declare var $: any;

@Component({
    selector: 'app-add-part-kit-modal',
    templateUrl: './add-part-kit.modal.html',
    styleUrls: ['./add-part-kit.modal.scss']
})
// tslint:disable-next-line:component-class-suffix
export class AddPartKitModal implements OnInit, AfterViewInit {
    public onClose: Subject<boolean>;

    title: string = 'Add part kit';
    closeBtnName: string = 'Cancel';
    form: FormGroup;
    action: string = '';
    formModel = {
        partName: '',
        quantity: 1,
        partStatus:''
    };
    select2Config: any;
    selectedPartId: any;
    selectedKitParts: any[] = [];
    jobId:number;
    customerId:number;
    customerType:string;
    @ViewChild('saveBtn') saveBtn: ElementRef;
    @Input()enablePartStatus = 3;
    select2PartStatusConfig:any={};
    partStatus = [];

    constructor(
        private formBuilder: FormBuilder,
        @Inject('$scope') private ajsScope,
        // private httpService: TemplatesConfigService,
        public bsModalRef: BsModalRef,
        private changeDetector: ChangeDetectorRef,
        private systemSettingsService: SystemSettingsService,
        private jobViewService: JobViewService,
    ) {}

    ngOnInit() {
        this.onClose = new Subject();

        this.form = this.formBuilder.group({
            partName: [this.formModel.partName, Validators.required],
            quantity: [this.formModel.quantity, [Validators.required, Validators.min(1)]]
        });
        if (this.partStatus.length > 0) {
            this.form.addControl('partStatus', new FormControl(this.formModel.partStatus || '', Validators.required));
        }

        this.initSelect2Config();
    }

    initSelect2Config() {
        this.select2Config = {
            multiple: false,
            width: '100%',
            placeholder: 'Select a part kit',
            allowClear: true,
            minimumInputLength: 2,
            ajax: {
                url: `${environment.apiHost}${environment.apiBasePath}getPartKitList`,
                data: (searchText, page) => {
                    if (!searchText) return false;
                    return {'q': encodeURIComponent(searchText) };
                },
                results: (data) => {
                    return { results: data || [] };
                }
            }
        };

        this.select2PartStatusConfig = {
            width: '100%',
            placeholder: '-- Select option--',
            data: this.partStatus.map((status, index) => ({
                id: status.text,
                text: status.text
            }))
        };
    }

    ngAfterViewInit() {
        const that = this;
        $('#part-kit').on('change', function (e) {
            that.selectedPartId = $('#part-kit').select2('val');
            if (that.selectedPartId) {
                that.form.get('partName').setValue(that.selectedPartId);
            } else {
                that.form.get('partName').setValue('');
            }
            that.form.get('partName').updateValueAndValidity();
            that.setSelectedValue(that.selectedPartId);
        });

        setTimeout(() => {
            this.saveBtn.nativeElement.focus();
        }, 900);
    }

    get f() {
        return this.form.controls;
    }

    updateTotalParts() {
        const multiplier = +this.form.get('quantity').value || 1;

        this.selectedKitParts.forEach(part => {
            part.totalQty = part.quantity * multiplier;
        });
    }

    blockZero(event: KeyboardEvent) {
        if (this.form.get('quantity').value == null && event.key === '0') {
            event.preventDefault();
        }
    }

    save() {
        if (this.form.invalid) return;

        this.action = 'saving';

        const payload = {
            kitId: this.form.get('partName').value,
            setQuantity: this.form.get('quantity').value
        };
        if(this.partStatus.length > 0){
            payload['partStatus']=this.form.get('partStatus').value;
        }

        this.jobViewService.savePartKit(this.customerId,this.customerType,this.jobId,payload).subscribe(
            (resp) => {
                this.action = '';
                this.onClose.next(true);
                this.bsModalRef.hide();
            },
            (error) => {
                this.action = '';
                console.error('Error saving part kit config:', error);
            }
        );
    }

    setSelectedValue($event) {
        if($event == ''){
            this.form.get('partName').reset();
            this.selectedKitParts = [];
        }else{
            this.jobViewService.getPartKitList($event).subscribe(data => {
                if(data){
                    this.selectedKitParts = data;
                    this.updateTotalParts()
                }
            })
        }
    }
}
